import "parsleyjs";
import "selectric";
import { CLASSES, STRINGS } from "@/scripts/helpers/constants";
import {
  disableElement,
  enableElement
} from "@/scripts/helpers/elementsActions";
import {
  onLeadFormSubmitCustomEvt,
  onCEApiLeadformSubmit,
  onCELeadformSubmit,
  onCEApiSandboxSubmit
} from "@/scripts/helpers/googleAnalyticsEvents";

export const handleFormCallback = (formId, callbackFn) => {
  const form = $("#" + formId);
  const formSubmit = form.find("." + CLASSES.FORM_SUBMIT);

  if (form.length) {
    form
      .parsley()
      .on("form:success", function () {
        disableElement(formSubmit);
      })
      .on("form:submit", function () {
        if (typeof callbackFn === "function") {
          callbackFn.call();
          return false;
        }
      });
  }
};

// Forms functionality
const { ERROR_MESSAGE_EMAIL, ERROR_MESSAGE_FIRST_NAME, ERROR_MESSAGE_LAST_NAME, ERROR_MESSAGE_PHONE, ERROR_MESSAGE_COMPANY_NAME, ERROR_MESSAGE_JOB, ERROR_MESSAGE_COMPANY_SIZE, ERROR_MESSAGE_PASSWORD } = STRINGS;

const fields = [{
  name: "email",
  messages: {
    required: ERROR_MESSAGE_EMAIL
  }
}, {
  name: "first_name",
  messages: {
    required: ERROR_MESSAGE_FIRST_NAME
  }
}, {
  name: "last_name",
  messages: {
    required: ERROR_MESSAGE_LAST_NAME
  }
}, {
  name: "phone",
  messages: {
    required: ERROR_MESSAGE_PHONE
  }
}, {
  name: "company_name",
  messages: {
    required: ERROR_MESSAGE_COMPANY_NAME
  }
}, {
  name: "job_title",
  messages: {
    required: ERROR_MESSAGE_JOB
  }
}, {
  name: "users",
  messages: {
    required: ERROR_MESSAGE_COMPANY_SIZE
  }
}, {
  name: "password",
  messages: {
    required: ERROR_MESSAGE_PASSWORD
  }
}];

const attachParsleyMessages = (form, options) => {
  if (form.length) {
    options.map(option => {
      const { name } = option;
      const { messages } = option;
      const { required } = messages;
      const select = form.find(`select[name=${name}]`);
      const input = form.find(`input[name=${name}]`);

      if (select.length && !select.data("parsleyRequiredMessage")) {
        select.attr("data-parsley-required-message", required);
      }
      if (input.length && !input.data("parsleyRequiredMessage")) {
        input.attr("data-parsley-required-message", required);
      }
    });
  }
};

const hideErrorByEvent = event => {
  $(`.${CLASSES.FORM_INPUT}`).on(event, function () {
    const input = $(this);
    input.parsley().reset();
  });
};

export const handleParsleyActions = () => {
  const forms = $("form");

  if (forms.length) {
    forms.each(function() {
      const form = $(this);
      const formBtn = form.find(".form-submit");

      form.attr("data-parsley-focus", "none");
      attachParsleyMessages(form, fields);

      form
        .parsley({
          requiredMessage: "This field is required",
          errorsWrapper: "<div class='parsley-errors-list'></div>",
          errorTemplate: "<div class='parsley-errors-list__item'></div>"
        })
        .on("field:error", function() {
          const field = this.$element;
          const selectWrapperClass = ".selectric-wrapper";
          if (field.is("select")) {
            const selectWrapper = field.parents(selectWrapperClass);

            if (selectWrapper.length) selectWrapper.addClass("has-error");
          }
        })
        .on("form:error", function() {
          const control = $(".parsley-error:first");
          control.focus()
          const label = control
            .parent()
            .parent()
            .find(".form-label");

          const labelHeight = label.height() + 10;
          const controlTopOffset = control.offset().top - labelHeight;
          if (control.length && label.length && !label.inView())
            window.scrollTo({ top: controlTopOffset, behavior: "smooth" });
        })
        .on("form:submit", function() {
          if (formBtn.length) {
            formBtn.attr("disabled", "disabled");
          }
        });
    });
  }
  hideErrorByEvent("keypress");
};

export const handleForms = () => {
  const forms = $("form");

  if (forms.length) {
    forms.on("submit", function(event) {
      const form = $(this);
      const methodPost = form.attr("method");
      const actionForm = form.attr("action");
      const select2 = form.find(".form__item--employees");
      const formBtnText = form.find(".form-submit").text();
      const checkedApi = form.find("input[name='api']:checked").val();

      if (form.parsley().isValid()) {
        if (methodPost !== undefined && methodPost.toUpperCase() === "POST") {
          onLeadFormSubmitCustomEvt(checkedApi, formBtnText);
          onCEApiLeadformSubmit(form, select2, checkedApi);
          onCELeadformSubmit(form, select2, checkedApi, actionForm);
          onCEApiSandboxSubmit(actionForm);
        } 
      }
    });
  }
};

Parsley.addMessages("en", {
  type: {
    email: STRINGS.EMAIL_ERROR_MESSAGE
  }
});

export const initCustomSelectPlugin = () => {
  const hideCustomSelectError = event => {
    const select = $(event);

    if (select.length && select.hasClass("parsley-error")) {
      const selectWrapper = select.parents(".selectric-wrapper.has-error");

      if (selectWrapper.length) selectWrapper.removeClass("has-error");
      select.parsley().reset();
    }
  };

  $("select").not(".contact-form__employees, .modal-employees").selectric({
    onOpen: hideCustomSelectError,
    onChange: hideCustomSelectError
  });
};
